import React from "react";
import HomeBanner from "./HomeBanner";
import HomeBannerTwo from "./HomeBannerTwo";
import "./Carousel.css";
const Combine = () => {
  return (
    <div className="bg-banner bg-[#407147] sm:pb-12 pb-20 lg:pb-0">
      <HomeBanner />
      <HomeBannerTwo />
    </div>
  );
};

export default Combine;
